/**
 * Enriches decorated routes with volume data from the shipment API.
 * Pure business logic — belongs in tools/ per API-Organization.md convention.
 *
 * @param {Array} decoratedRoutes - Routes already decorated with shipment data
 * @param {Object} shipmentApi - The shipment API (mainApi.shipment)
 * @returns {Promise<Array>} Routes with loadVolume on each shipment and route.load totals
 */
async function enrichRoutesWithVolumes (decoratedRoutes, shipmentApi) {
  const allShipmentIds = decoratedRoutes.reduce((ids, route) => {
    route.shipments.forEach(s => { if (s.shipment_id) ids.push(s.shipment_id) })
    return ids
  }, [])

  if (allShipmentIds.length === 0) {
    return decoratedRoutes
  }

  const batchProductSkuById = await shipmentApi.resolveBatchProductSkusForShipments(allShipmentIds)
  const volumes = await shipmentApi.calculateVolume({ shipmentIds: allShipmentIds, batchProductSkuById })
  const volumeMap = (volumes || []).reduce((map, v) => {
    map[v.shipment_id] = parseFloat(v.total_volume) || 0
    return map
  }, {})

  return decoratedRoutes.map(route => {
    let routeLoad = 0
    const shipments = route.shipments.map(s => {
      const loadVolume = volumeMap[s.shipment_id] || 0
      routeLoad += loadVolume
      return { ...s, loadVolume }
    })
    return { ...route, shipments, load: routeLoad }
  })
}

module.exports = { enrichRoutesWithVolumes }
